export default "__VITE_ASSET__CESAmrUU__"